import { Menu, MenuItem } from '@mui/material';
import * as React from 'react';

import { Action } from '../../actions';

interface Props {
  anchor: HTMLElement | null;
  onClose: () => void;
  onAction: (action: Action) => void;
  enabledActions: Action[];
}

export const ActionMenu: React.FC<Props> = (props) => {
  const { anchor, enabledActions, onAction, onClose } = props;
  return (
    <Menu open={!!anchor} onClose={onClose} anchorEl={anchor}>
      <MenuItem onClick={() => onAction('delete')} disabled={!enabledActions.includes('delete')}>
        Delete
      </MenuItem>
      <MenuItem onClick={() => onAction('update')} disabled={!enabledActions.includes('update')}>
        Update
      </MenuItem>
    </Menu>
  );
};
ActionMenu.displayName = 'ActionMenu';
